/**
 * $(selector).MTAppJSONTable();
 * textareaを表形式の入力欄にし、表に入力された値をJSONで元のtextareaに保存します。
 * このメソッドで扱えるJSONのフォーマットは下記の通りです。
 * {"items":[
 *     {"key1": "value1", "key2": "value2", "key3": "value3"},
 *     {"key1": "value1", "key2": "value2", "key3": "value3"},
 *     {"key1": "value1", "key2": "value2", "key3": "value3"}
 * ]}
 *
 * @requires jQuery
 * @param options
 * @return {*}
 * @constructor
 */
import { isPlainObject } from '../isPlainObject.js';

export function MTAppJSONTable(options) {
    const $ = window.jQuery;
    const op = $.extend(
        {
            inputType: 'textarea', // 'textarea' or 'input'
            caption: null, // String: Table caption
            header: null, // Object: Table header
            headerOrder: [], // Array: Order of table header
            headerPosition: 'top', // 'top' or 'left'
            footer: false, // If you use the table footer, set true.
            items: null, // Array include Object
            itemsRootKey: 'items', // String: The root key of items
            edit: true, // Disable table
            add: false, // true: A user can add rows or columns.
            clear: true, // false: Hide a delete button.
            cellMerge: false,
            sortable: false,
            listingCheckbox: false, // or true
            listingCheckboxType: 'checkbox', // or 'radio'
            listingTargetKey: null, // String: Target key  which is saved value when listing mode is applied
            listingTargetEscape: false, // Boolean: encodeURIComponent(target value)
            optionButtons: null, // [{classname:"classname", text:"button text"}]
            // Callbacks
            cbAfterBuildSystem: null, // function({name: 'cbAfterBuild'}, $container){}
            cbAfterBuild: null, // function({name: 'cbAfterBuild'}, $container){}
            cbBeforeAdd: null, // function({name: 'cbBeforeAdd', type: 'column'}, $td){}
            cbAfterAddSystem: null, // function({name: 'cbAfterAdd', type: 'row or column'}, $container){}
            cbAfterAdd: null, // function({name: 'cbAfterAdd', type: 'row or column'}, $container){}
            cbBeforeClear: null, // function({name: 'cbAfterAdd'}, $container){}
            cbAfterSelectRow: null, // function({name: 'cbAfterSelectRow'}, $tr, $(this).is(':checked')){}
            cbAfterSelectColumn: null, // function({name: 'cbAfterSelectColumn'}, $td, $(this).is(':checked')){}
            cbBeforeSave: null, // function({name: 'cbBeforeSave'}, $container, $this){}
            cbAfterSave: null, // function({name: 'cbAfterSave'}, $container, $this, savedJSON){}

            nest: false, // backward compatible
            debug: false // true: show the original textarea.
        },
        options
    );

    const l10n = {};
    if (mtappVars.language === 'ja') {
        l10n.addRow = '行を追加';
        l10n.addColumn = '列を追加';
        l10n.clearData = '削除';
        l10n.showJSON = 'JSONを表示';
        l10n.hideJSON = 'JSONを非表示';
        l10n.debugMessage = 'フィールドが表示されているときはテーブル内の値は無視され、フィールド内の JSON がそのまま保存されます。';
        l10n.checkSyntax = 'JSONの文法をチェック';
        l10n.addColumnProperty = 'プロパティ名（例：title）';
        l10n.addColumnPropertyDisplayName = 'プロパティ表示名（例：タイトル）';
        l10n.cellMerge = 'セルを結合';
        l10n.cellMergeApply = '結合を適用';
        l10n.colspanValueIs = '結合する列の数';
        l10n.rowspanValueIs = '結合する行の数';
        l10n.failedSelect = '連続したセルを選択してください';
    } else {
        l10n.addRow = 'Add a row';
        l10n.addColumn = 'Add a column';
        l10n.clearData = 'Delete';
        l10n.showJSON = 'Show JSON';
        l10n.hideJSON = 'Hide JSON';
        l10n.debugMessage = 'When the field is visible, ignore table values and save JSON.';
        l10n.checkSyntax = 'Check JSON syntax';
        l10n.addColumnProperty = 'Property Name (e.g. title)';
        l10n.addColumnPropertyDisplayName = 'Property Display Name (e.g. Title)';
        l10n.cellMerge = 'Merge cells';
        l10n.cellMergeApply = 'Apply merge';
        l10n.colspanValueIs = 'The value of colspan:';
        l10n.rowspanValueIs = 'The value of rowspan:';
        l10n.failedSelect = 'Failed to select';
    }

    // Auto settings
    if (op.clear) {
        op.listingCheckbox = true;
    }

    return this.each(function () {
        // Check the headerOrder of properties
        const order = op.headerOrder;
        if (Array.isArray(order) && order.length === 0) {
            alert('Error in .MTAppJSONTable: The "headerOrder" option is required.');
            return;
        }

        const $this = $(this);
        $this.addClass('hidden').css({
            marginBottom: '10px'
        });

        // Bind to the nearest form (MT screens often have multiple forms)
        const $form = $this.closest('form');

        const jsonStr = $this.val();
        let json = null;
        if (/^\{/.test(jsonStr)) {
            try {
                json = JSON.parse(jsonStr);
            } catch (e) {
                alert(e.message);
            }
        } else {
            if (op.items === null) {
                json = {};
                json[op.itemsRootKey] = [];
            } else {
                json = op.items;
            }
        }
        if (json === null) {
            return;
        }

        const items = json[op.itemsRootKey];
        if (items.length === 0) {
            items[0] = {};
            for (let i = 0, l = order.length; i < l; i++) {
                items[0][order[i]] = '';
            }
        }

        // Merge headerOrder to JSON
        if (!op.cellMerge) {
            for (let i = 0, l = order.length; i < l; i++) {
                for (let x = 0, y = items.length; x < y; x++) {
                    if (!Object.prototype.hasOwnProperty.call(items[x], order[i])) {
                        items[x][order[i]] = '';
                    }
                }
            }
        }

        // XSS対策
        for (let i = 0, l = items.length; i < l; i++) {
            for (let prop in items[i]) {
                if (typeof items[i][prop] === 'string') {
                    items[i][prop] = items[i][prop].encodeHTML();
                } else if (typeof items[i][prop] === 'object') {
                    items[i][prop] = JSON.stringify(items[i][prop]);
                }
            }
        }

        op.items = items;

        let itemLength = op.items.length;
        const tmpl = {};

        tmpl.caption = '<caption>[#= caption #]</caption>';

        tmpl.header = [
            '<thead>',
            '<tr>',
            '[# if (sortable) { #]',
            '<th class="jsontable-sort-handle">&nbsp;</th>',
            '[# } #]',
            // op.clear == true
            '[# if (listingCheckbox) { #]',
            '<th class="jsontable-cb-cell">&nbsp;</th>',
            '[# } #]',
            '[# for (let i = 0, l = headerOrder.length; i < l; i++) { #]',
            '<th class="[#= headerOrder[i] #]" data-name="[#= headerOrder[i] #]">[#= header[headerOrder[i]] #]</th>',
            '[# } #]',
            '</tr>',
            '</thead>'
        ].join('\n');

        tmpl.footer = [
            '<tfoot>',
            '<tr>',
            '[# if (sortable) { #]',
            '<th class="mt-table-thead-th jsontable-sort-handle">&nbsp;</th>',
            '[# } #]',
            '[# if (listingCheckbox) { #]',
            '<th class="mt-table-thead-th jsontable-cb-cell">&nbsp;</th>',
            '[# } #]',
            '[# for (let i = 0, l = headerOrder.length; i < l; i++) { #]',
            '<th class="mt-table-thead-th [#= headerOrder[i] #]" data-name="[#= headerOrder[i] #]">[#= header[headerOrder[i]] #]</th>',
            '[# } #]',
            '</tr>',
            '</tfoot>'
        ].join('\n');

        tmpl.tbodyTopPlain = [
            '<tr class="odd">',
            '[# if (sortable) { #]',
            '<td class="jsontable-sort-handle"><svg role="img" title="移動" class="mt-icon"><use xlink:href="' +
                mtappVars.static_path +
                'images/sprite.svg#ic_move"></use></svg></td>',
            '[# } #]',
            '[# if (listingCheckbox) { #]',
            '<td class="jsontable-cb-cell">',
            '[# if (listingCheckboxType === "radio") { #]',
            '<input type="radio" name="jsontable-radio" class="jsontable-cb">',
            '[# } else { #]',
            '<input type="checkbox" class="jsontable-cb">',
            '[# } #]',
            '</td>',
            '[# } #]',
            '[# for (let x = 0, y = headerOrder.length; x < y; x++) { #]',
            '<td class="[#= headerOrder[x] #]" data-name="[#= headerOrder[x] #]">',
            '[# if (inputType === "input" || (inputType === "object" && inputTypeObj[headerOrder[x]] && inputTypeObj[headerOrder[x]] === "input") ) { #]',
            '<input class="form-control jsontable-input" type="text" data-name="[#= headerOrder[x] #]" value="">',
            '[# } else if (inputType === "number" || (inputType === "object" && inputTypeObj[headerOrder[x]] && inputTypeObj[headerOrder[x]] === "number") ) { #]',
            '<input class="form-control jsontable-input" type="number" data-name="[#= headerOrder[x] #]" value="">',
            '[# } else if (inputType === "date" || (inputType === "object" && inputTypeObj[headerOrder[x]] && inputTypeObj[headerOrder[x]] === "date") ) { #]',
            '<input class="form-control jsontable-input" type="date" data-name="[#= headerOrder[x] #]" value="">',
            '[# } else if (inputType === "time" || (inputType === "object" && inputTypeObj[headerOrder[x]] && inputTypeObj[headerOrder[x]] === "time") ) { #]',
            '<input class="form-control jsontable-input" type="time" data-name="[#= headerOrder[x] #]" value="">',
            '[# } else if (inputType === "color" || (inputType === "object" && inputTypeObj[headerOrder[x]] && inputTypeObj[headerOrder[x]] === "color") ) { #]',
            '<input class="form-control jsontable-input" type="color" data-name="[#= headerOrder[x] #]" value="">',
            '[# } else if (inputType === "email" || (inputType === "object" && inputTypeObj[headerOrder[x]] && inputTypeObj[headerOrder[x]] === "email") ) { #]',
            '<input class="form-control jsontable-input" type="email" data-name="[#= headerOrder[x] #]" value="">',
            '[# } else if (inputType === "url" || (inputType === "object" && inputTypeObj[headerOrder[x]] && inputTypeObj[headerOrder[x]] === "url") ) { #]',
            '<input class="form-control jsontable-input" type="url" data-name="[#= headerOrder[x] #]" value="">',
            '[# } else if (inputType === "tel" || (inputType === "object" && inputTypeObj[headerOrder[x]] && inputTypeObj[headerOrder[x]] === "tel") ) { #]',
            '<input class="form-control jsontable-input" type="tel" data-name="[#= headerOrder[x] #]" value="">',
            '[# } else if (inputType === "textarea" || (inputType === "object" && inputTypeObj[headerOrder[x]] && inputTypeObj[headerOrder[x]] === "textarea") ) { #]',
            '<textarea class="form-control jsontable-input" data-name="[#= headerOrder[x] #]"></textarea>',
            '[# } #]',
            '</td>',
            '[# } #]',
            '</tr>'
        ].join('');

        tmpl.tbodyTop = [
            '<tbody class="jsontable-tbody">',
            '[# for (let i = 0, l = items.length; i < l; i++) { #]',
            '[# if (i % 2 === 0) { #]',
            '<tr class="even">',
            '[# } else { #]',
            '<tr class="odd">',
            '[# } #]',
            '[# if (sortable) { #]',
            '<td class="jsontable-sort-handle"><svg role="img" title="移動" class="mt-icon"><use xlink:href="' +
                mtappVars.static_path +
                'images/sprite.svg#ic_move"></use></svg></td>',
            '[# } #]',
            '[# if (listingCheckbox) { #]',
            '<td class="jsontable-cb-cell">',
            '[# if (listingCheckboxType === "radio") { #]',
            '<input type="radio" name="jsontable-radio" class="jsontable-cb">',
            '[# } else { #]',
            '<input type="checkbox" class="jsontable-cb">',
            '[# } #]',
            '</td>',
            '[# } #]',
            '[# for (let x = 0, y = headerOrder.length; x < y; x++) { #]',
            '[# if (!items[i].hasOwnProperty(headerOrder[x])) { continue; } #]',
            '<td class="[#= headerOrder[x] #]" data-name="[#= headerOrder[x] #]"',
            '[# if (listingTargetKey && listingTargetKey === headerOrder[x]) { #]',
            '[# if (listingTargetEscape) { #]',
            'data-value="[#= encodeURIComponent(items[i][headerOrder[x]]) #]"',
            '[# } else { #]',
            'data-value="[#= items[i][headerOrder[x]] #]"',
            '[# } #]',
            '[# } #]',
            // Cell Merge
            '[# if (items[i].hasOwnProperty(headerOrder[x] + "_colspan")) { #]',
            'colspan="[#= items[i][headerOrder[x] + "_colspan"] #]"',
            '[# } #]',
            '[# if (items[i].hasOwnProperty(headerOrder[x] + "_rowspan")) { #]',
            'rowspan="[#= items[i][headerOrder[x] + "_rowspan"] #]"',
            '[# } #]',
            '>',
            '[# if (edit) { #]',
            '[# if (inputType === "input" || (inputType === "object" && inputTypeObj[headerOrder[x]] && inputTypeObj[headerOrder[x]] === "input") ) { #]',
            '<input class="form-control jsontable-input" type="text" data-name="[#= headerOrder[x] #]" value="[#= items[i][headerOrder[x]] #]">',
            '[# } else if (inputType === "number" || (inputType === "object" && inputTypeObj[headerOrder[x]] && inputTypeObj[headerOrder[x]] === "number") ) { #]',
            '<input class="form-control jsontable-input" type="number" data-name="[#= headerOrder[x] #]" value="[#= items[i][headerOrder[x]] #]">',
            '[# } else if (inputType === "date" || (inputType === "object" && inputTypeObj[headerOrder[x]] && inputTypeObj[headerOrder[x]] === "date") ) { #]',
            '<input class="form-control jsontable-input" type="date" data-name="[#= headerOrder[x] #]" value="[#= items[i][headerOrder[x]] #]">',
            '[# } else if (inputType === "time" || (inputType === "object" && inputTypeObj[headerOrder[x]] && inputTypeObj[headerOrder[x]] === "time") ) { #]',
            '<input class="form-control jsontable-input" type="time" data-name="[#= headerOrder[x] #]" value="[#= items[i][headerOrder[x]] #]">',
            '[# } else if (inputType === "color" || (inputType === "object" && inputTypeObj[headerOrder[x]] && inputTypeObj[headerOrder[x]] === "color") ) { #]',
            '<input class="form-control jsontable-input" type="color" data-name="[#= headerOrder[x] #]" value="[#= items[i][headerOrder[x]] #]">',
            '[# } else if (inputType === "email" || (inputType === "object" && inputTypeObj[headerOrder[x]] && inputTypeObj[headerOrder[x]] === "email") ) { #]',
            '<input class="form-control jsontable-input" type="email" data-name="[#= headerOrder[x] #]" value="[#= items[i][headerOrder[x]] #]">',
            '[# } else if (inputType === "url" || (inputType === "object" && inputTypeObj[headerOrder[x]] && inputTypeObj[headerOrder[x]] === "url") ) { #]',
            '<input class="form-control jsontable-input" type="url" data-name="[#= headerOrder[x] #]" value="[#= items[i][headerOrder[x]] #]">',
            '[# } else if (inputType === "tel" || (inputType === "object" && inputTypeObj[headerOrder[x]] && inputTypeObj[headerOrder[x]] === "tel") ) { #]',
            '<input class="form-control jsontable-input" type="tel" data-name="[#= headerOrder[x] #]" value="[#= items[i][headerOrder[x]] #]">',
            '[# } else if (inputType === "textarea" || (inputType === "object" && inputTypeObj[headerOrder[x]] && inputTypeObj[headerOrder[x]] === "textarea") ) { #]',
            '<textarea class="form-control jsontable-input" data-name="[#= headerOrder[x] #]">[#= items[i][headerOrder[x]] #]</textarea>',
            '[# } #]',
            '[# } else { #]',
            '<span class="jsontable-input-data">[#= items[i][headerOrder[x]] #]</span>',
            '[# if (listingTargetKey && listingTargetKey === headerOrder[x]) { #]',
            '<textarea class="form-control jsontable-input-hidden hidden" data-name="[#= headerOrder[x] #]">[#= items[i][headerOrder[x]] #]</textarea>',
            '[# } #]',
            '[# } #]',
            '</td>',
            '[# } #]',
            '</tr>',
            '[# } #]',
            '</tbody>'
        ].join('');

        tmpl.tbodyLeftPlain = [
            '<td class="[#= headerOrder #] item-[#= i #] last-child" data-item-index="[#= i #]" data-name="[#= headerOrder #]">',
            '[# if (inputType === "input" || (inputType === "object" && inputTypeObj[headerOrder] && inputTypeObj[headerOrder] === "input") ) { #]',
            '<input class="form-control jsontable-input" type="text" data-name="[#= headerOrder #]" value="">',
            '[# } else if (inputType === "number" || (inputType === "object" && inputTypeObj[headerOrder] && inputTypeObj[headerOrder] === "number") ) { #]',
            '<input class="form-control jsontable-input" type="number" data-name="[#= headerOrder #]" value="">',
            '[# } else if (inputType === "date" || (inputType === "object" && inputTypeObj[headerOrder] && inputTypeObj[headerOrder] === "date") ) { #]',
            '<input class="form-control jsontable-input" type="date" data-name="[#= headerOrder #]" value="">',
            '[# } else if (inputType === "time" || (inputType === "object" && inputTypeObj[headerOrder] && inputTypeObj[headerOrder] === "time") ) { #]',
            '<input class="form-control jsontable-input" type="time" data-name="[#= headerOrder #]" value="">',
            '[# } else if (inputType === "color" || (inputType === "object" && inputTypeObj[headerOrder] && inputTypeObj[headerOrder] === "color") ) { #]',
            '<input class="form-control jsontable-input" type="color" data-name="[#= headerOrder #]" value="">',
            '[# } else if (inputType === "email" || (inputType === "object" && inputTypeObj[headerOrder] && inputTypeObj[headerOrder] === "email") ) { #]',
            '<input class="form-control jsontable-input" type="email" data-name="[#= headerOrder #]" value="">',
            '[# } else if (inputType === "url" || (inputType === "object" && inputTypeObj[headerOrder] && inputTypeObj[headerOrder] === "url") ) { #]',
            '<input class="form-control jsontable-input" type="url" data-name="[#= headerOrder #]" value="">',
            '[# } else if (inputType === "tel" || (inputType === "object" && inputTypeObj[headerOrder] && inputTypeObj[headerOrder] === "tel") ) { #]',
            '<input class="form-control jsontable-input" type="tel" data-name="[#= headerOrder #]" value="">',
            '[# } else if (inputType === "textarea" || (inputType === "object" && inputTypeObj[headerOrder] && inputTypeObj[headerOrder] === "textarea") ) { #]',
            '<textarea class="form-control jsontable-input" data-name="[#= headerOrder #]"></textarea>',
            '[# } #]',
            '</td>'
        ].join('');

        tmpl.tbodyLeft = [
            '<tbody class="jsontable-tbody">',
            '[# if (listingCheckbox) { #]',
            '<tr class="jsontable-clear-row">',
            '[# if (header) { #]',
            '<th class="mt-table-thead-th jsontable-cb-cell">&nbsp;</th>',
            '[# } #]',
            '[# for (let i = 0, l = items.length; i < l; i++) { #]',
            '<td class="jsontable-cb-cell item-[#= i #]" data-item-index="[#= i #]">',
            '<input type="checkbox" class="jsontable-cb">',
            '</td>',
            '[# } #]',
            '</tr>',
            '[# } #]',
            '[# for (let x = 0, y = headerOrder.length; x < y; x++) { #]',
            '<tr class="[#= headerOrder[x] #]" data-name="[#= headerOrder[x] #]">',
            '[# for (let i = 0, l = items.length; i < l; i++) { #]',
            '[# if (!items[i].hasOwnProperty(headerOrder[x])) { continue; } #]',
            '<td class="[#= headerOrder[x] #] item-[#= i #]" data-item-index="[#= i #]" data-name="[#= headerOrder[x] #]"',
            // Cell Merge
            '[# if (items[i].hasOwnProperty(headerOrder[x] + "_colspan")) { #]',
            'colspan="[#= items[i][headerOrder[x] + "_colspan"] #]"',
            '[# } #]',
            '[# if (items[i].hasOwnProperty(headerOrder[x] + "_rowspan")) { #]',
            'rowspan="[#= items[i][headerOrder[x] + "_rowspan"] #]"',
            '[# } #]',
            '>',
            '[# if (edit) { #]',
            '[# if (inputType === "input" || (inputType === "object" && inputTypeObj[headerOrder[x]] && inputTypeObj[headerOrder[x]] === "input") ) { #]',
            '<input class="form-control jsontable-input" type="text" data-name="[#= headerOrder[x] #]" value="[#= items[i][headerOrder[x]] #]">',
            '[# } else if (inputType === "number" || (inputType === "object" && inputTypeObj[headerOrder[x]] && inputTypeObj[headerOrder[x]] === "number") ) { #]',
            '<input class="form-control jsontable-input" type="number" data-name="[#= headerOrder[x] #]" value="[#= items[i][headerOrder[x]] #]">',
            '[# } else if (inputType === "date" || (inputType === "object" && inputTypeObj[headerOrder[x]] && inputTypeObj[headerOrder[x]] === "date") ) { #]',
            '<input class="form-control jsontable-input" type="date" data-name="[#= headerOrder[x] #]" value="[#= items[i][headerOrder[x]] #]">',
            '[# } else if (inputType === "time" || (inputType === "object" && inputTypeObj[headerOrder[x]] && inputTypeObj[headerOrder[x]] === "time") ) { #]',
            '<input class="form-control jsontable-input" type="time" data-name="[#= headerOrder[x] #]" value="[#= items[i][headerOrder[x]] #]">',
            '[# } else if (inputType === "color" || (inputType === "object" && inputTypeObj[headerOrder[x]] && inputTypeObj[headerOrder[x]] === "color") ) { #]',
            '<input class="form-control jsontable-input" type="color" data-name="[#= headerOrder[x] #]" value="[#= items[i][headerOrder[x]] #]">',
            '[# } else if (inputType === "email" || (inputType === "object" && inputTypeObj[headerOrder[x]] && inputTypeObj[headerOrder[x]] === "email") ) { #]',
            '<input class="form-control jsontable-input" type="email" data-name="[#= headerOrder[x] #]" value="[#= items[i][headerOrder[x]] #]">',
            '[# } else if (inputType === "url" || (inputType === "object" && inputTypeObj[headerOrder[x]] && inputTypeObj[headerOrder[x]] === "url") ) { #]',
            '<input class="form-control jsontable-input" type="url" data-name="[#= headerOrder[x] #]" value="[#= items[i][headerOrder[x]] #]">',
            '[# } else if (inputType === "tel" || (inputType === "object" && inputTypeObj[headerOrder[x]] && inputTypeObj[headerOrder[x]] === "tel") ) { #]',
            '<input class="form-control jsontable-input" type="tel" data-name="[#= headerOrder[x] #]" value="[#= items[i][headerOrder[x]] #]">',
            '[# } else if (inputType === "textarea" || (inputType === "object" && inputTypeObj[headerOrder[x]] && inputTypeObj[headerOrder[x]] === "textarea") ) { #]',
            '<textarea class="form-control jsontable-input" data-name="[#= headerOrder[x] #]">[#= items[i][headerOrder[x]] #]</textarea>',
            '[# } #]',
            '[# } else { #]',
            '<span class="jsontable-input-data">[#= items[i][headerOrder[x]] #]</span>',
            '[# if (listingTargetKey && listingTargetKey === headerOrder[x]) { #]',
            '<textarea class="form-control jsontable-input-hidden hidden" data-name="[#= headerOrder[x] #]">[#= items[i][headerOrder[x]] #]</textarea>',
            '[# } #]',
            '[# } #]',
            '</td>',
            '[# } #]',
            '</tr>',
            '[# } #]',
            '</tbody>'
        ].join('');

        tmpl.buttons = [
            '<div class="add-btn text-right mt-3">',
            '[# if (add && headerPosition === "top") { #]',
            '<a href="#" class="btn btn-default ml-2 jsontable-add jsontable-add-row">' + l10n.addRow + '</a>',
            '[# } #]',
            '[# if (add && headerPosition === "left") { #]',
            '<a href="#" class="btn btn-default ml-2 jsontable-add jsontable-add-column">' + l10n.addColumn + '</a>',
            '[# } #]',
            '[# if (cellMerge) { #]',
            '<a href="#" class="btn ml-2 btn-warning jsontable-cellMerge">' + l10n.cellMerge + '</a>',
            '[# } #]',
            '[# if (clear) { #]',
            '<a href="#" class="btn btn-danger ml-2 jsontable-clear">' + l10n.clearData + '</a>',
            '[# } #]',
            '[# if (debug) { #]',
            '<a href="#" class="btn ml-2 btn-success jsontable-debug">' + l10n.showJSON + '</a>',
            '<a href="#" class="btn ml-2 btn-info jsontable-check-json primary hidden">' + l10n.checkSyntax + '</a>',
            '[# } #]',
            '[# if (optionButtons) { #]',
            '[# for (let i = 0, l = optionButtons.length; i < l; i++) { #]',
            '<a href="#" class="btn btn-default ml-2 [#= optionButtons[i].classname #]">[#= optionButtons[i].text #]</a>',
            '[# } #]',
            '[# } #]',
            '</div>'
        ].join('');

        tmpl.debugMessage = ['<div class="alert alert-warning jsontable-debug-message hidden">' + l10n.debugMessage + '</div>'].join('');

        tmpl.container = [
            '<div class="mtapp-json-table">',
            '<table class="table table-bordered mt-table  jsontable-table">',
            // caption
            '[# if (typeof caption === "string") { #]',
            '[#= context.include("caption") #]',
            '[# } #]',

            // header
            '[# if (header && headerPosition === "top") { #]',
            '[#= context.include("header") #]',
            '[# } #]',

            // footer
            '[# if (header && headerPosition === "top" && footer) { #]',
            '[#= context.include("footer") #]',
            '[# } #]',

            // tbody
            '[# if (items.length > 0) { #]',
            '[# if (headerPosition === "top") { #]',
            '[#= context.include("tbodyTop") #]',
            '[# } else if (headerPosition === "left") { #]',
            '[#= context.include("tbodyLeft") #]',
            '[# } #]',
            '[# } #]',

            '</table>',

            '[# if (add || clear || optionButtons || debug) { #]',
            '[#= context.include("buttons") #]',
            '[# } #]',

            '</div>'
        ].join('\n');

        // Build HTML and insert a table.
        if (isPlainObject(op.inputType)) {
            op.inputTypeObj = op.inputType;
            op.inputType = 'object';
        }

        const tableHtml = Template.process('container', op, tmpl);
        $(this).after(tableHtml);

        const $container = $this.next('div');
        const $table = $container.children('table');
        $table.data('item-length', itemLength);

        // Ensure JSON is updated before MT's JS-driven submits / autosaves.
        // - MT may submit the form programmatically (bypassing native submit handlers)
        // - MT auto-save collects values via DOM.getFormData without submitting
        if ($form.length) {
            const formEl = $form[0];
            if (!formEl.__mtappJSONTableHooksInstalled) {
                formEl.__mtappJSONTableHooksInstalled = true;

                // Capture submit-button clicks BEFORE bubbling handlers that may call form.submit().
                formEl.addEventListener(
                    'click',
                    function (e) {
                        const target = e.target && e.target.closest
                            ? e.target.closest('button[type="submit"], input[type="submit"]')
                            : null;
                        if (!target) return;
                        $(formEl).find('textarea').triggerHandler('MTAppJSONTableSave');
                    },
                    true
                );

                // Auto-save: update JSON right before MT collects form data.
                $(window).on('pre_autosave', function () {
                    $(formEl).find('textarea').triggerHandler('MTAppJSONTableSave');
                });
            }
        }

        // If the "headerPosition" option is "left", insert th to tr.
        if (op.header && op.headerPosition === 'left') {
            $table
                .find('tr')
                .not('.jsontable-clear-row')
                .each(function () {
                    const dataName = $(this).attr('data-name');
                    $(this).prepend(
                        '<th class="mt-table-thead-th ' + dataName + '" data-name="' + dataName + '">' + op.header[dataName] + '</th>'
                    );
                });
        }

        // Click checkboxes for deleting data
        if (op.listingCheckbox) {
            if (op.headerPosition === 'top') {
                $table.on('click', 'input.jsontable-cb', function () {
                    const $tr = $(this).parent().parent().toggleClass('jsontable-selected-data');
                    if (op.cbAfterSelectRow !== null && typeof op.cbAfterSelectRow === 'function') {
                        op.cbAfterSelectRow({ name: 'cbAfterSelectRow' }, $tr, $(this).is(':checked'));
                    }
                });
            } else if (op.headerPosition === 'left') {
                $table.on('click', 'input.jsontable-cb', function () {
                    const itemIndex = $(this).parent().attr('data-item-index');
                    const $td = $table.find('.item-' + itemIndex).toggleClass('jsontable-selected-data');
                    if (op.cbAfterSelectColumn !== null && typeof op.cbAfterSelectColumn === 'function') {
                        op.cbAfterSelectColumn({ name: 'cbAfterSelectColumn' }, $td, $(this).is(':checked'));
                    }
                });
            }
        }

        // Add a row or column
        if (op.add || op.clear) {
            $container.on('click', 'div.add-btn a', function () {
                if ($(this).hasClass('jsontable-add-row')) {
                    const plainTr = Template.process('tbodyTopPlain', op, tmpl);
                    if (op.cbBeforeAdd !== null && typeof op.cbBeforeAdd === 'function') {
                        op.cbBeforeAdd({ name: 'cbBeforeAdd', type: 'row' }, $container);
                    }
                    $table.find('tbody.jsontable-tbody').append(plainTr);
                    if (op.cbAfterAddSystem !== null && typeof op.cbAfterAddSystem === 'function') {
                        op.cbAfterAddSystem({ name: 'cbAfterAddSystem', type: 'row' }, $container);
                    }
                    if (op.cbAfterAdd !== null && typeof op.cbAfterAdd === 'function') {
                        op.cbAfterAdd({ name: 'cbAfterAdd', type: 'row' }, $container);
                    }
                } else if ($(this).hasClass('jsontable-add-column')) {
                    const headerOrderClone = $.extend(true, [], op.headerOrder);
                    // $table.find('td:last-child').each(function(){
                    //     var idx = $(this).index();
                    //     if (idx > dataItemIndex) {
                    //         dataItemIndex = idx;
                    //     }
                    // });
                    $table.find('tr').each(function () {
                        let $td = $(this)
                            .children(':last-child')
                            .removeClass('last-child')
                            .clone()
                            .removeClass(function (index, classname) {
                                return (classname.match(/\bitem-\d+/g) || []).join(' ');
                            });
                        if ($(this).hasClass('jsontable-clear-row')) {
                            $td.attr('data-item-index', itemLength).addClass('item-' + itemLength);
                        } else {
                            var data = {
                                headerOrder: headerOrderClone.shift(),
                                inputType: op.inputType,
                                inputTypeObj: op.inputTypeObj,
                                i: itemLength
                            };
                            $td = Template.process('tbodyLeftPlain', data, tmpl);
                        }
                        if (op.cbBeforeAdd !== null && typeof op.cbBeforeAdd === 'function') {
                            op.cbBeforeAdd({ name: 'cbBeforeAdd', type: 'column' }, $td);
                        }
                        $(this).append($td);
                    });
                    itemLength++;
                    $table.data('item-length', itemLength);
                    if (op.cbAfterAddSystem !== null && typeof op.cbAfterAddSystem === 'function') {
                        op.cbAfterAddSystem({ name: 'cbAfterAddSystem', type: 'column' }, $container);
                    }
                    if (op.cbAfterAdd !== null && typeof op.cbAfterAdd === 'function') {
                        op.cbAfterAdd({ name: 'cbAfterAdd', type: 'column' }, $container);
                    }
                } else if ($(this).hasClass('jsontable-clear')) {
                    if (op.cbBeforeClear !== null && typeof op.cbBeforeClear === 'function') {
                        op.cbBeforeClear({ name: 'cbBeforeClear' }, $container);
                    }
                    $table.find('.jsontable-selected-data').remove();
                    if (op.headerPosition === 'left') {
                        itemLength--;
                        $table.data('item-length', itemLength);
                    }
                }
                return false;
            });
        }

        if (op.cellMerge) {
            $container.on('click', 'a.jsontable-cellMerge', function () {
                $(this).toggleClass('primary');
                var selectMergedCell = function () {
                    var $td = $(this);
                    $td.toggleClass('merge-target');
                };
                // Select merged cells
                if ($(this).hasClass('primary')) {
                    // Clear classes
                    $table.find('td.merge-target').removeClass('merge-target');
                    $(this).text(l10n.cellMergeApply);
                    $table.on('click', 'td', selectMergedCell);
                }
                // Apply merge
                else {
                    $(this).text(l10n.cellMerge);
                    $table.off('click', 'td');
                    var $mergeTarget = $table.find('td.merge-target');
                    var firstCell = {},
                        firstLine = {},
                        firstLineLastCell = {},
                        lastCell = {},
                        lastLine = {};
                    firstCell.obj = $mergeTarget.first();
                    firstCell.idx = firstCell.obj.index();
                    firstLine.obj = firstCell.obj.parent();
                    firstLine.idx = firstLine.obj.index();
                    firstLineLastCell.obj = firstLine.obj.children('.merge-target').last();
                    firstLineLastCell.idx = firstLineLastCell.obj.index();
                    lastCell.obj = $mergeTarget.last();
                    lastCell.idx = lastCell.obj.index();
                    lastLine.obj = lastCell.obj.parent();
                    lastLine.idx = lastLine.obj.index();
                    var colspan = firstLine.obj.children('.merge-target').length;
                    var rowspan = lastLine.idx - firstLine.idx + 1;
                    // Check existed colspan values
                    var existedColspan = 0;
                    firstLine.obj
                        .children('.merge-target')
                        .filter('[colspan]')
                        .each(function () {
                            existedColspan += Number($(this).attr('colspan'));
                        });
                    if (existedColspan) {
                        colspan += existedColspan - 1;
                    }
                    if (colspan > 1) {
                        firstCell.obj.attr('colspan', colspan);
                    }
                    if (rowspan > 1) {
                        firstCell.obj.attr('rowspan', rowspan);
                    }
                    $table.find('td.merge-target').not(':first').remove();
                }
                $table.toggleClass('jsontable-cell-merge');
                return false;
            });
        }

        if (op.debug) {
            $this.before(Template.process('debugMessage', {}, tmpl));
            $container.on('click', 'a.jsontable-debug', function () {
                if ($(this).hasClass('showed-json')) {
                    $(this).removeClass('showed-json').text(l10n.showJSON).next().addClass('hidden');
                    $this.addClass('hidden').prev().addClass('hidden');
                } else {
                    $(this).addClass('showed-json').text(l10n.hideJSON).next().removeClass('hidden');
                    $this.removeClass('hidden').prev().removeClass('hidden');
                }
                return false;
            });
            $container.on('click', 'a.jsontable-check-json', function () {
                try {
                    json = JSON.parse($this.val());
                } catch (e) {
                    alert(e.message);
                    return false;
                }
                alert('Valid');
                return false;
            });
        }

        // Save values edited by user
        if (op.edit) {
            const runSave = function () {
                if ($this.is(':visible')) {
                    // Debug mode: when original field is visible, table values are ignored
                    return;
                }
                if (op.cbBeforeSave !== null && typeof op.cbBeforeSave === 'function') {
                    op.cbBeforeSave({ name: 'cbBeforeSave' }, $container, $this);
                }
                const result = save(op.headerPosition, op.itemsRootKey, $table, ':not(".hidden")', op.nest);
                $this.val(result.replace(/^(\s|\n)+$/g, ''));
                if (op.cbAfterSave !== null && typeof op.cbAfterSave === 'function') {
                    op.cbAfterSave({ name: 'cbAfterSave' }, $container, $this, result);
                }
            };

            // Prefer the nearest form; fall back for legacy callers.
            const formEl = ($form && $form.length && $form[0]) || $('form[method="post"]')[0];
            if (formEl) {
                formEl.addEventListener(
                    'submit',
                    function () {
                        runSave();
                    },
                    true
                );
            }
            $this.on('MTAppJSONTableSave', function () {
                runSave();
            });
        }
        if (op.sortable && op.headerPosition === 'top') {
            $table.sortable({
                items: 'tbody tr',
                handle: 'td.jsontable-sort-handle',
                cursor: 'move'
            });
        }
        if (op.cbAfterBuildSystem !== null && typeof op.cbAfterBuildSystem === 'function') {
            op.cbAfterBuildSystem({ name: 'cbAfterBuildSystem' }, $container);
        }
        if (op.cbAfterBuild !== null && typeof op.cbAfterBuild === 'function') {
            op.cbAfterBuild({ name: 'cbAfterBuild' }, $container);
        }
    });
}
function save(headerPosition, itemsRootKey, $table, filter, nest) {
    const $ = window.jQuery;
    var values = '';
    var itemsArray = [];
    if (typeof filter !== 'string') {
        filter = '';
    }
    if (headerPosition === 'top') {
        $table.find('tbody.jsontable-tbody > tr' + filter).each(function () {
            var item = {};
            $(this)
                .find('.jsontable-input')
                .each(function () {
                    var v = $(this).val();
                    if (nest) {
                        if (/^\s*".+?"\s*$/.test(v)) {
                            v = JSON.stringify(v);
                        }
                        try {
                            v = JSON.parse(v);
                        } catch {
                            // nothing to do
                        }
                    }
                    item[$(this).attr('data-name')] = v;

                    // cellMerge
                    if ($(this).parent().attr('colspan')) {
                        item[$(this).attr('data-name') + '_colspan'] = $(this).parent().attr('colspan');
                    }
                    if ($(this).parent().attr('rowspan')) {
                        item[$(this).attr('data-name') + '_rowspan'] = $(this).parent().attr('rowspan');
                    }
                    values += v;
                });
            itemsArray.push(JSON.stringify(item));
        });
    } else if (headerPosition === 'left') {
        var $tr = $table.find('tr' + filter);
        var itemsArrayObj = [];
        var itemLength = $table.data('item-length');
        for (let i = 0; i < itemLength; i++) {
            itemsArrayObj.push({});
        }
        $tr.each(function () {
            $(this)
                .find('.jsontable-input')
                .each(function () {
                    var v = $(this).val();
                    if (nest) {
                        if (/^\s*".+?"\s*$/.test(v)) {
                            v = JSON.stringify(v);
                        }
                        try {
                            v = JSON.parse(v);
                        } catch {
                            // nothing to do
                        }
                    }
                    var idx = $(this).parent().attr('data-item-index');
                    itemsArrayObj[idx][$(this).attr('data-name')] = v;

                    // cellMerge
                    if ($(this).parent().attr('colspan')) {
                        itemsArrayObj[idx][$(this).attr('data-name') + '_colspan'] = $(this).parent().attr('colspan');
                    }
                    if ($(this).parent().attr('rowspan')) {
                        itemsArrayObj[idx][$(this).attr('data-name') + '_rowspan'] = $(this).parent().attr('rowspan');
                    }

                    values += v;
                });
        });
        for (let i = 0; i < itemLength; i++) {
            itemsArray.push(JSON.stringify(itemsArrayObj[i]));
        }
    }
    return values !== '' ? '{"' + itemsRootKey + '":[' + itemsArray.join(',') + ']}' : '';
}
